export default "__VITE_ASSET__COcRWU36__"